
const Button = ({ children, onClick, onMouseDown, className, disabled } : { children, onClick?, onMouseDown?, className?, disabled? }) => {
  return (
    <button
      type="button"
      className={`bg-green-500 hover:bg-green-700 ${disabled ? 'bg-gray-200 hover:bg-gray-200 text-gray-500' : ''} text-white text-lg font-bold py-1 px-4 rounded focus:outline-none ${className}`}
      onClick={onClick}
      onMouseDown={onMouseDown}
      disabled={disabled || false}
    >
      {children}
    </button>
  )
}

export default Button;